<template>
  <FaLayer v-tooltip="tooltip">
    <FaIcon
      :class="{
        ['IconColor IconColor--'+selectedIcon?.color]: selectedIcon?.color,
        [selectedIcon?.class]: selectedIcon?.class
      }"
      :mask="isC2c && !selectedIcon.subIcon ? selectedIcon.icon : (selectedIcon.mask || null)"
      :icon="isC2c && !selectedIcon.subIcon ? 'circle' : selectedIcon.icon"
      :transform="isC2c && !selectedIcon.subIcon ? 'shrink-4 left-7 down-6' : (selectedIcon.transform || null)"
      :opacity="selectedIcon?.opacity || null"
      :style="selectedIcon?.style || {}"
      />
    <FaIcon v-if="isC2c && !selectedIcon.subIcon"
      color='white'
      :icon="['far', 'circle-video']"
      transform='shrink-4 left-7 down-6'
    />
    <FaIcon
      v-if="selectedIcon?.subIcon"
      :class="{
        ['IconColor IconColor--'+selectedIcon?.subColor]: selectedIcon?.subColor,
        ['IconColor IconColor--'+selectedIcon?.color]: !selectedIcon?.subColor,
        [selectedIcon?.subClass]: selectedIcon?.subClass && selectedIcon?.subIcon !== 'triangle-exclamation'
      }"
      :icon="selectedIcon?.subIcon"
      :mask="selectedIcon?.subMask && ['fas', selectedIcon?.subMask] || null"
      :transform="selectedIcon?.subTransform || null"
      :opacity="selectedIcon?.subOpacity || null"
      :style="selectedIcon?.subStyle || null"
    />
  </FaLayer>
</template>

<script lang="ts">
import { getGatewayIconWithSyncStatus } from '@/constants/gateway';
import { eGatewayType_enum } from '@/graphql/types';
import { CAMERA_DEFAULT_ICON } from '@/constants/camera';
import { mixinFaIcons, mixinStatusProps } from '@/icons/mixins';
import { faCircleVideo } from '@fortawesome/pro-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { isBoolean } from '@/functions/boolean';
import { defineComponent } from 'vue';

library.add(faCircleVideo);

export default defineComponent({
  mixins: [mixinFaIcons],
  props: {
    ...mixinStatusProps,
    // TODO :: uses enum... use validation method once enum is available
    sync: {
      type: String,
      required: false,
      default: ''
    },
    type: {
      type: String,
      default: eGatewayType_enum.Gateway,
      required: false,
    },
  },
  methods: {
    isBoolean
  },
  computed: {
    isC2c() {
      return this.type == eGatewayType_enum.Camera
    },
    videoIcon() {
      return CAMERA_DEFAULT_ICON;
    },
    selectedIcon() {
      const selected = getGatewayIconWithSyncStatus(this.status, {
        syncStatus: !this.isC2c ? this.sync : undefined,
        disabled: this.disabled
      })

      const reversedIcon = !!selected.mask;

      return {
        ...selected,
        icon: reversedIcon ? selected.mask : selected.icon,
        mask: reversedIcon ? selected.icon : selected?.mask,
      }
    },
    tooltip() {
      const { selectedIcon, disabled } = this
      if (disabled || !selectedIcon?.value) return false
      return {
        triggers: ['click', 'hover', 'focus'],
        content: `Gateway: ${selectedIcon?.tooltip}`,
      }
    }
  }
});
</script>
